// Moved from `src/hooks/query/useQueryClinicalTaskById.ts` (now a shim) with
// the D2 family (ARCFE-945). No user-visible effect to sever: errors log and
// surface through the query's own state.
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { logger } from '@heidi/runtime/logger';

import { GET_CLINICAL_TASK_BY_ID } from '../../contracts/keys';
import type { ClinicalTask } from '../../contracts/types';
import { getClinicalTaskById } from '../api/clinical-tasks';

export const useQueryClinicalTaskById = (taskId: string | null) => {
  return useQuery<ClinicalTask | null, Error>({
    queryKey: [GET_CLINICAL_TASK_BY_ID, taskId],
    queryFn: async () => {
      if (!taskId) return null;
      try {
        const { data } = await getClinicalTaskById(taskId);
        return data.task ?? null;
      } catch (error) {
        logger.error(
          'Error fetching task by id:',
          error instanceof AxiosError
            ? { status: error.response?.status, message: error.message }
            : error
        );
        throw error;
      }
    },
    enabled: !!taskId,
    retry: false,
    gcTime: 0,
  });
};
